import React from "react";
import { motion } from "framer-motion";
import {
  ShieldCheck,
  Languages,
  Leaf,
  Clock4,
  UserCheck,
  CalendarClock,
} from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { ABOUT_IMG } from "@/lib/brand";

const ICONS = [ShieldCheck, Languages, Leaf, Clock4, UserCheck, CalendarClock];

export default function WhyUs() {
  const { t } = useI18n();
  return (
    <section data-testid="why-section" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-white/10">
            <img src={ABOUT_IMG} alt="Modern clean home" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-black via-black/30 to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-bl from-[#EC008C]/25 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-6 bg-[#EC008C] rounded-2xl px-6 py-4 shadow-[0_20px_60px_-10px_rgba(236,0,140,0.6)] hidden sm:block">
            <div className="font-display text-3xl font-black text-white leading-none">100%</div>
            <div className="text-[10px] uppercase tracking-widest text-white/90 mt-1">
              Satisfacción
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#FF1F87]">
            {t.why.eyebrow}
          </span>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-black tracking-tight">
            {t.why.title}
          </h2>

          <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {t.why.items.map((w, idx) => {
              const Icon = ICONS[idx % ICONS.length];
              return (
                <motion.div
                  key={w.t}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: idx * 0.05 }}
                  data-testid={`why-item-${idx}`}
                  className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-5 hover:border-[#EC008C]/50 transition-colors"
                >
                  <div className="w-10 h-10 rounded-xl bg-[#EC008C]/15 border border-[#EC008C]/30 flex items-center justify-center mb-4">
                    <Icon className="w-4.5 h-4.5 text-[#FF66B3]" />
                  </div>
                  <h3 className="font-semibold text-white">{w.t}</h3>
                  <p className="text-xs text-zinc-400 mt-1.5 leading-relaxed">{w.d}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
